import React from 'react';
import {useTranslation} from 'react-i18next';
import SectionWrapper from './section-wrapper';

const descAgentLevelImage = require('@/pages/agent/assets/desc-agent-level.webp');

const AgentLevelDescription: React.FC = () => {
  const {t} = useTranslation();

  return (
    <SectionWrapper title={t('agent.rules.agentLevelDescription.title')}>
      {/* 代理等级图片 */}
      <div className="flex justify-center">
        <img
          src={descAgentLevelImage}
          alt="Agent Level Description"
          className="w-full max-w-[20rem] h-auto"
        />
      </div>

      {/* 等级说明文本 */}
      <div className="space-y-1">
        <p className="text-xs font-medium text-black">
          {t('agent.rules.agentLevelDescription.level1')}
        </p>
        <p className="text-xs font-medium text-black">
          {t('agent.rules.agentLevelDescription.level2')}
        </p>
        <p className="text-xs font-medium text-black">
          {t('agent.rules.agentLevelDescription.level3')}
        </p>
        <p className="text-xs font-medium text-black">
          {t('agent.rules.agentLevelDescription.level4')}
        </p>
      </div>

      {/* 底部说明 */}
      <div className="bg-bg rounded-lg p-2">
        <p className="text-xs text-[rgba(0,0,0,0.8)] leading-normal">
          {t('agent.rules.agentLevelDescription.description')}
        </p>
      </div>
    </SectionWrapper>
  );
};

export default AgentLevelDescription;
